"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCommentConnuConsultimCorporation = void 0;
exports.ESubCommentConnuConsultimCorporation = {
    presse: "presse",
    email: "email",
    connseillerFinancier: "connseillerFinancier",
    recommandation: "recommandation",
    internet: "internet",
    publicitePresse: "publicitePresse",
    autre: "autre",
};
